//#region types
import { OtherGroupProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import {
  SelectInputItemProps,
  SelectInputProps,
  TextInputWithSuggestionsProps,
} from "models/propTypes/wintFormPropsTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { HorizontalFormField, SelectInput, GroupSection, TextInputWithSuggestions } from "components/common/wintForms";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function OtherGroup({ connect, values, paymentOptions, sellers, isQuotation }: OtherGroupProps) {
  return (
    <GroupSection
      header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Other)}
      icon={IconDefinitionConstants.WUser}
    >
      <HorizontalFormField<TextInputWithSuggestionsProps>
        Component={TextInputWithSuggestions}
        {...connect("otherSettings.sellerName")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Seller)}
        controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.SellerDescription)}
        suggestions={sellers}
        optional
      />
      {isQuotation ||
      (paymentOptions?.length === 1 && paymentOptions[0].id === values.otherSettings.paymentMethodId) ? (
        <></>
      ) : (
        <HorizontalFormField<SelectInputProps>
          Component={SelectInput}
          {...connect("otherSettings.paymentMethodId")}
          label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.PaymentOption)}
          descriptionText={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Invoice.PaymentOptionHelpText
          )}
          items={paymentOptions?.map(
            (item): SelectInputItemProps => ({
              value: item.id,
              label: `${LocalizationHelperInstance.getFormattedMessage(`Invoice.PaymentMethods_${item.method}`)} ${
                item.number ?? ""
              }`,
            })
          )}
        />
      )}
    </GroupSection>
  );
}

export default OtherGroup;
